import React, { useEffect, useRef } from 'react';
import { PrimaryButton } from 'utils';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

const RecurringPaymentForm = ({
  paymentType,
  isTicketable,
  setElements,
  setStripe,
  options,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const paymentContainerRef = useRef(null);
  useEffect(() => {
    setStripe(stripe);
    setElements(elements);
  }, [elements, setElements, setStripe, stripe]);

  // Keep view at top when PaymentElement (e.g., SEPA) mounts and grabs focus
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    if (!elements) return;
    const enforceTop = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (_) {}
    };
    const onFocusIn = (e) => {
      if (
        paymentContainerRef.current &&
        paymentContainerRef.current.contains(e.target)
      ) {
        enforceTop();
      }
    };
    // Initial and repeated kicks to cover lazy-mounted SEPA and internal focus
    const kicks = [0, 300, 700, 1200, 2000, 3000];
    const timers = kicks.map((ms) => setTimeout(enforceTop, ms));

    // Observe Stripe iframe insertion and re-enforce top on mutations
    let observer;
    if (paymentContainerRef.current) {
      observer = new MutationObserver(() => enforceTop());
      observer.observe(paymentContainerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener('focusin', onFocusIn, true);
    return () => {
      timers.forEach(clearTimeout);
      document.removeEventListener('focusin', onFocusIn, true);
      if (observer) observer.disconnect();
    };
  }, [elements]);

  return (
    <div>
      <div>
        {paymentType === 'card' && (
          <>
            <div className="payment_blk_in" ref={paymentContainerRef}>
              <PaymentElement id="payment-element" {...options} />
            </div>
            <PrimaryButton
              type="submit"
              minWidth={'100%'}
              claPRACTICE
              GROUP
              ssName="payPalBtn"
              // onClick={onFinish}
              style={{ marginBottom: '1px', marginTop: '25px' }}
            >
              Jetzt zahlungspflichtig {isTicketable ? 'buchen' : 'unterstützen'}
            </PrimaryButton>
          </>
        )}
      </div>
    </div>
  );
};

export default RecurringPaymentForm;
